// JavaScript Document

// Scripts written by Jacob Bearce @ Weblinx, Inc.

import ScrollHint from "scroll-hint";

// init ScrollHint
new ScrollHint(".text__table__container");
